module.exports = __webpack_public_path__ + "static/img/其他分馆.a4669550.png";